<template>
    <div v-loading="loading">
        <my-table :data="tableData" height="500px" v-if="tableShow">
            <el-table-column label="标段" prop="by2" min-width="180"></el-table-column>
            <el-table-column label="回执时间" prop="hzdate" min-width="140">
                <template slot-scope="scope">
                    {{scope.row.hzdate}}:00
                </template>
            </el-table-column>
            <el-table-column label="回执单位名称" prop="adddwname" min-width="180"></el-table-column>
            <el-table-column label="回执单位编号" prop="adddwcode" min-width="140"></el-table-column>
        </my-table>

        <my-pagination 
            ref="page" 
            v-if="tableShow"
            v-model="tableData"
            :lazy="true"
            :search="pgData" 
            :action="`${getGetters('mngUrl')}/FaBiao/ZbFile/`+processType+`get_yhzbm.json`">
        </my-pagination>
        
        <div v-if="!tableShow" style="height:500px;text-align:center;margin-top:30px">
            <my-tag type="danger"><i class="el-icon-warning"></i>{{content}}</my-tag>
        </div>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'

export default {
    mixins: [LIST_PAGE_MIXIN],
    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return{
            pgData: {
                sortname:'hzdate',
                procode:this.data.procode,
                id:this.data.id,
            },
            tableShow:true,
            processType:'',
            content:'',
            loading:false,
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        
    },
    created() {
        var that = this
        if(that.data.isXt=='1'){
            that.processType = 'xingtai/'
        }
        that.loading = true
        that.jspInit(`${that.getGetters('ageUrl')}/FaBiao/ZbFile/`+that.processType+`/Hzlist.json`, {
            id:that.getQuery('id'),
            procode:that.getQuery('procode'),
        },(data, res) => {
            if(data.title){
                that.tableShow = false;
                that.content = data.content;
                that.loading = false;
            }else{
                that.loading = false;
                that.$refs.page.queryData(1);
            }

        });
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">
    /deep/ .el-tag.el-tag--danger{ font-size: 28px; }
    /deep/ .el-tag--mini{ line-height: 60px; }
</style>
